/**
 * Цвет полосы прогресса (решение владельца 28.10.2026, одинаково в CRM KPI и KPI Mag):
 * ниже 100 % плана — красный, ровно 100 % — жёлтый, выше — зелёный.
 * Для обратных показателей (возвраты, замечания, выговоры): хуже нормы — красный, ровно норма — жёлтый, лучше — зелёный.
 */
export type Tone = "under" | "norm" | "over";

/** Сравнение с допуском на округление до 0,1 % (на экране проценты с одним знаком). */
const EPS = 0.0005;

/** ratio = факт / план. */
export function toneOfRatio(ratio: number): Tone {
  if (ratio > 1 + EPS) return "over";
  if (ratio < 1 - EPS) return "under";
  return "norm";
}

/** Обратный показатель: меньше — лучше (возвраты %, замечания, выговоры). */
export function toneOfInverse(fact: number, norm: number): Tone {
  if (fact > norm + EPS) return "under";
  if (fact < norm - EPS) return "over";
  return "norm";
}

export const TONE_BG: Record<Tone, string> = { under: "bg-rose-500", norm: "bg-amber-400", over: "bg-emerald-500" };
export const TONE_HEX: Record<Tone, string> = { under: "#ef4444", norm: "#fbbf24", over: "#10b981" };
